import { Injectable } from '@angular/core';
import { IndexedDBService } from 'src/app/services/indexeddb';

@Injectable({ providedIn: 'root' })
export class SessionService {
  constructor(private readonly indexedDBService: IndexedDBService) {}

  logout(): void {
    localStorage.clear();
    this.indexedDBService.deleteDatabase();
    window.location.href = '/login';
  }
}
